import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureAmplify } from './auth/amplify';
import { AuthProvider } from './auth/AuthContext';
import { ApolloAppProvider } from './apollo/ApolloAppProvider';
import { I18nProvider } from './i18n';
import { App } from './App';
import './index.css';

// Configure Cognito (Amplify Auth) before rendering so the auth session is
// available to the auth context and the Apollo links.
configureAmplify();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element "#root" not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <I18nProvider>
      <AuthProvider>
        <ApolloAppProvider>
          <App />
        </ApolloAppProvider>
      </AuthProvider>
    </I18nProvider>
  </StrictMode>,
);
